/**
 * JobsTab - Job history tab component for the agent drawer
 *
 * Provides job history with filtering for Praetorian users.
 * Re-exports JobHistoryPane content adapted for drawer context.
 */

import React from 'react';

import type { Agent } from '@/hooks/useAgents';
import { JobHistoryPane } from '@/sections/agents/components/aegis-management/job/JobHistoryPane';

interface JobsTabProps {
  agent: Agent;
  isActiveTab: boolean;
}

export const JobsTab: React.FC<JobsTabProps> = ({ agent, isActiveTab }) => {
  return (
    <div className="flex h-full flex-col" data-testid="agent-drawer-jobs-tab">
      <JobHistoryPane agent={agent} isActiveTab={isActiveTab} />
    </div>
  );
};
